/* eslint-disable import/prefer-default-export */
export const theme = {
  colors: {
    white: '#fff',
    text: '#666666',
    blue: '#0577DE',
  },
};
